import moment from 'moment-timezone';

export function getTimezoneAbbreviation(tzId) {
  return tzId ? moment.tz(tzId).format('z') : 'UTC';
}

export function convertDateToTz(date, tzId = 'UTC', format = 'MMMM Do, YYYY') {
  return moment.tz(date, tzId).format(format);
}
